import React, { useEffect, useState } from "react";
import { Quote, Star } from "lucide-react";
import { fetchTestimonials } from "../lib/api";

export default function TestimonialWall() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTestimonials()
      .then((d) => setItems(d.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  // Hide entire section if no consented testimonials yet
  if (!loading && items.length === 0) return null;

  return (
    <section data-testid="testimonial-wall-section" className="bg-stone-900 text-sand-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.22em] text-saffron-300 font-medium">
              Voices of Families
            </div>
            <h2 className="font-serif text-3xl lg:text-4xl mt-3 text-sand-50 leading-tight">
              Real words from parents and students who chose Atmia.
            </h2>
          </div>
          <Quote className="w-12 h-12 text-saffron-400 hidden sm:block" strokeWidth={1.25} />
        </div>

        {loading ? (
          <div className="text-stone-400 text-sm">Loading testimonials…</div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="testimonial-grid">
            {items.map((t) => (
              <article
                key={t.id}
                data-testid={`testimonial-${t.id}`}
                className="bg-stone-800/60 backdrop-blur-sm border border-stone-700/60 rounded-2xl p-7 hover:border-saffron-500/40 transition-all hover:-translate-y-0.5"
              >
                {t.rating ? (
                  <div className="flex items-center gap-0.5 mb-4" aria-label={`${t.rating} of 5 stars`}>
                    {Array.from({ length: 5 }).map((_, i) => (
                      <Star
                        key={i}
                        className={`w-4 h-4 ${i < t.rating ? "fill-saffron-400 text-saffron-400" : "text-stone-600"}`}
                        strokeWidth={1.5}
                      />
                    ))}
                  </div>
                ) : null}
                <p className="font-serif italic text-lg leading-relaxed text-sand-50/95">
                  “{t.quote}”
                </p>
                <div className="mt-6 pt-5 border-t border-stone-700/60 text-sm">
                  <div className="text-sand-50 font-medium">{t.parent_name}</div>
                  <div className="text-stone-400 text-xs mt-0.5">
                    {t.student_name ? `Student: ${t.student_name}` : null}
                    {t.city_branch ? ` · ${t.city_branch}` : null}
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
